import React from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function SidebarMinifyBtn() {
	return (
		<AppSettings.Consumer>
			{({toggleAppSidebarMinify}) => (
				<div className="menu-item d-flex">
					<Link to="/" className="app-sidebar-minify-btn ms-auto d-flex align-items-center text-decoration-none" onClick={toggleAppSidebarMinify}>
						<i className="fa fa-angle-double-left"></i>
					</Link>
				</div>
			)}
		</AppSettings.Consumer>
	)
}

export default SidebarMinifyBtn;
